"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludeCollectionsByKey = void 0;
const excludeCollectionsByKey = (key) => (target, selected) => {
    return target.filter(({ [key]: targetId }) => {
        return !selected.some(({ [key]: selectedId }) => {
            return targetId === selectedId;
        });
    });
};
exports.excludeCollectionsByKey = excludeCollectionsByKey;
//# sourceMappingURL=excludeCollectionsByKey.js.map